"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _style = require("./style");
var _constants = require("./constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Button = _ref => {
  let {
    disabled = false,
    className: passedClassName,
    variant,
    children,
    ...props
  } = _ref;
  const classes = (0, _style.useStyles)();
  const labelButton = /*#__PURE__*/_react.default.createElement("button", _extends({
    type: "button",
    className: (0, _clsx.default)(classes.labelButton, {
      [classes.labelButtonDisabled]: disabled
    }, passedClassName),
    disabled: disabled
  }, props), children);
  const muiButton = /*#__PURE__*/_react.default.createElement(Button, _extends({
    variant: variant,
    className: passedClassName,
    disabled: disabled
  }, props), children);
  switch (variant) {
    case _constants.BUTTON_VARIANT.LABEL:
      {
        return labelButton;
      }
    default:
      {
        return muiButton;
      }
  }
};
exports.Button = Button;